import MessageBox from './MessageBox';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';

const ResetPasswordFail = () => {
  return (
    <MessageBox
      header="Whoops!"
      message="Your password reset has failed."
      secondaryMessage={SUPPORT_MESSAGE}
    />
  );
};

export default ResetPasswordFail;
